@if (state$ | async; as state) {
    @if (state.alert) {
        <app-alert [alertConfig]="state.alert"></app-alert>
    }
}
<router-outlet />
